import { createFileRoute } from "@tanstack/react-router";
import { ProjektassistancePage, projektassistanceHead } from "@/pages/ProjektassistancePage";

export const Route = createFileRoute("/de/projektassistenz")({
  head: () => projektassistanceHead("de"),
  component: () => <ProjektassistancePage locale="de" />,
});
